module.exports = __webpack_public_path__ + "static/media/hideAdsMonth.29050895.svg";